// extracted by mini-css-extract-plugin
export default {"content":"Form_content__sP52s"};